module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-gebaeudehuelle-sanierung-3ad28d162b554927009990f4884a2327.svg";